import { EuiLoadingSpinner } from '@elastic/eui';
import { memo } from 'react';
import * as S from './TableInfoButton.style';

interface TableInfoButtonProps {
  onClick: () => void;
  children: string;
  icon: JSX.Element;
  showSpacer?: boolean;
  loading?: boolean;
}

export const TableInfoButton = memo(
  ({ loading = false, onClick, children, icon, showSpacer }: TableInfoButtonProps): JSX.Element => (
    <S.ExportButton onClick={onClick} $showSpacer={showSpacer} $loading={loading}>
      {loading ? <EuiLoadingSpinner style={{ marginRight: '5px' }} /> : icon}
      {children}
    </S.ExportButton>
  )
);
